import React from 'react';
import { usePages, useAuth } from 'api';
import { Text, PageCardLarge, Loading, Button, Header } from 'ui';
import { lightBlue } from 'config/colors';
import "./index.css";

export default function Pages(props) {
  const auth = useAuth();
  const pages = usePages(auth ? auth.company.id : null);
  
  if(!pages) {
    return <Loading/>;
  }
  
  if(pages.length === 0) {
    return (
      <div className="pages-placeholder">
        <Header>
          <Text large light style={{flex:1}}>Landing Pages</Text>
          <Button to="create" label="DESIGN A LANDING PAGE" small white style={{backgroundColor:lightBlue}}/>
        </Header>
        <div className="pages-placeholder-body">
          <Text huge block white>Design a Landing Page</Text>
          <Text white block>
            Taptivate’s landing page module is simple and robust. Whether your a pro-marketer or a non-technical business owner, you can design beautiful, high converting landing pages with our intuitive interface.
          </Text>
          <Button to="create" style={{backgroundColor:"white"}}>
            <Text color="#243746">Start Your First Landing Page</Text>
          </Button>
        </div>
      </div>
    );
  }
  
  return (
    <div className="pages">
      <Header>
        <Text large light style={{flex:1}}>Landing Pages</Text>
        <Button to="create" style={{backgroundColor:"#5cc2e8"}}>
          <Text small white>DESIGN A LANDING PAGE</Text>
        </Button>
      </Header>
      {pages ? (
        <div className="pages-grid">
          {pages.map(page => <PageCardLarge key={page.id} {...page}/>)}
        </div>
      ) : (
        <div style={{padding:40}}>
          <Loading/>
        </div>
      )}
    </div>
  );
}